import styled from 'styled-components';

import {
  U21Button,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { Unit21Logo } from 'app/shared/components/logos/Unit21Logo';

export const AppLoadError = () => {
  return (
    <Container align="center" spacing={2}>
      <StyledUnit21Logo />
      <TextCenter>
        <U21Typography textAlign="center" variant="h6">
          Something unexpected has happened. We have received the error and are
          working on it.
        </U21Typography>
        <U21Typography variant="h6">
          Please&nbsp;
          <U21Button
            color="primary"
            onClick={() => window.location.reload()}
            variant="text"
          >
            reload
          </U21Button>
          &nbsp;to try again.
        </U21Typography>
      </TextCenter>
      <U21Typography color="text.secondary" textAlign="center" variant="body1">
        If this issue persists, please&nbsp;
        <U21Button
          color="primary"
          href="https://unit21.zendesk.com/"
          variant="text"
        >
          contact Unit21
        </U21Button>
        &nbsp;for assistance.
      </U21Typography>
    </Container>
  );
};

const Container = styled(U21Spacer)`
  min-height: 100%;
  justify-content: center;
  padding: 0 40px 200px;
`;

const StyledUnit21Logo = styled(Unit21Logo)`
  width: 300px;
  height: 100%;
`;

const TextCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
